import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError, of } from 'rxjs';
import { RiskmapService } from '../../service/riskmap.service';
import { RelevanceActions } from './relevance.actions';

@Injectable()
export class RelevanceEffects {

  loadRelevance$ = createEffect(
    (rs: RiskmapService = inject(RiskmapService)) => {
      return this.actions$.pipe(

        ofType(RelevanceActions.loadRelevance),
        mergeMap((parameters) =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          rs.getRiskRelevanceByEntityAndCampaign(parameters.legalEntityId, parameters.campaignId, parameters.parameters).pipe(
            map((riskMap) => {
              return RelevanceActions.loadRelevanceSuccess({
                riskMap: riskMap,
                filtering: parameters?.filtering
              });
            }),
            catchError((error) => of(RelevanceActions.loadRelevanceFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  // updateRiskRelevance$ = createEffect(
  //   (rs: RelevanceService = inject(RelevanceService)) => {
  //     return this.actions$.pipe(

  //       ofType(RelevanceActions.changeRelevance),
  //       mergeMap((riskMap) =>
  //         rs.updateRelevance(riskMap.riskMap).pipe(
  //           map((relevance) => {
  //             return RelevanceActions.changeRelevanceSuccess({
  //               relevance: relevance
  //             });
  //           }),
  //           catchError((error) => of(RelevanceActions.changeRelevanceFailure({ error })))
  //         )
  //       )
  //     );
  //   },
  //   { functional: true }
  // );


  // updateRiskRelevanceByIds$ = createEffect(
  //   (
  //     rs: RelevanceService = inject(RelevanceService),
  //     ms: MessageService = inject(MessageService)
  //   ) => {
  //     return this.actions$.pipe(

  //       ofType(RelevanceActions.updateRelevance),
  //       mergeMap((riskRelevance) =>
  //         rs.updateRelevanceByIds(riskRelevance.riskRelevance).pipe(
  //           map((relevance) => {
  //             if (relevance?.invalidEntries && relevance.invalidEntries.length > 0) {
  //               ms.add({ severity: 'error', detail: 'There are relevances not saved caused by inconsistent data', life: 2000, closable: true })
  //             }
  //             return RelevanceActions.updateRelevanceSuccess({
  //               relevance: relevance?.updatedEntries?.processParameters as ProcessParameter[],
  //               invalidEntries: relevance?.invalidEntries as RelevanceResponse[]
  //             });
  //           }),
  //           catchError((error) => of(RelevanceActions.updateRelevanceFailure({ error })))
  //         )
  //       )
  //     );
  //   },
  //   { functional: true }
  // );

  constructor(private actions$: Actions) { }
}
